import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import GestureHandler from "./GestureHandler";
import PixelRatio from "react-native-web/dist/exports/PixelRatio";

var DraggingGestureHandler = function (_GestureHandler) {
  _inherits(DraggingGestureHandler, _GestureHandler);

  var _super = _createSuper(DraggingGestureHandler);

  function DraggingGestureHandler() {
    _classCallCheck(this, DraggingGestureHandler);

    return _super.apply(this, arguments);
  }

  _createClass(DraggingGestureHandler, [{
    key: "transformNativeEvent",
    value: function transformNativeEvent(_ref) {
      var deltaX = _ref.deltaX,
          deltaY = _ref.deltaY,
          velocityX = _ref.velocityX,
          velocityY = _ref.velocityY,
          _ref$center = _ref.center,
          x = _ref$center.x,
          y = _ref$center.y;
      var rect = this.view.getBoundingClientRect();
      var ratio = PixelRatio.get();
      return {
        translationX: deltaX - (this.__initialX || 0),
        translationY: deltaY - (this.__initialY || 0),
        absoluteX: x,
        absoluteY: y,
        velocityX: velocityX * ratio,
        velocityY: velocityY * ratio,
        x: x - rect.left,
        y: y - rect.top
      };
    }
  }, {
    key: "shouldEnableGestureOnSetup",
    get: function get() {
      return true;
    }
  }]);

  return DraggingGestureHandler;
}(GestureHandler);

export default DraggingGestureHandler;